import {
  MENTIONSNODE_NAME,
  MENTIONSNODE_TAG,
} from '~shared/richtext/nodes/mention.node'

import type { MentionDto } from '@/entities/mentions'
import { TiptapSuggestionsConfig } from '@/entities/tiptap-suggestions'

import type { SuggestionKeyDownProps } from '@tiptap/suggestion'

export const mentionsExtensionConfig = new TiptapSuggestionsConfig({
  name: MENTIONSNODE_NAME,
  nodeTag: MENTIONSNODE_TAG,
  character: '@',
  supportedNavigationKeys: ['ArrowUp', 'ArrowDown', 'Enter'],
})

export type MentionSuggestionsCommandReturn = {
  mention: MentionDto
}

export interface MentionSuggestionsHandle {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean
}
